const deletePrompt = {
  bindings: {
      deleteMethod: '&',
      buttonType: '@',
      itemType: '@'
  },
  controller: function($scope, $ionicPopup, $filter) {
    this.openPopup = ($event) => {
      $event.preventDefault();
      let dialogResult = $ionicPopup.confirm({
        title: deferPopupTitle($filter, this.itemType),
        template: deferPopupContent($filter, this.itemType)
      });

      dialogResult.then((res) => {
        if (res) {
          this.deleteMethod();
        }
      });
    };

    function deferPopupTitle($filter, itemType) {
      var popupTitle;
      switch (itemType) {
        case 'task':
          popupTitle = $filter('translate')('DELETE_TASK');
          break;
        case 'team':
          popupTitle = $filter('translate')('DELETE_TEAM');
          break;
        case 'teamMember':
          popupTitle = $filter('translate')('DELETE_TEAM_MEMBER');
          break;
        case 'campaign':
          popupTitle = $filter('translate')('DELETE_CAMPAIGN');
          break;
        case 'contact':
          popupTitle = $filter('translate')('DELETE_CONTACT');
          break;
        case 'investor':
          popupTitle = $filter('translate')('DELETE_INVESTOR');
          break;
        case 'cart':
          popupTitle = $filter('translate')('DELETE_CART');
          break;
        default:
          popupTitle = $filter('translate')('DELETE');
      }

      return popupTitle;
    }

    function deferPopupContent($filter, itemType) {
      var popupContent;
      switch (itemType) {
        case 'task':
          popupContent = $filter('translate')('DELETE_TASK_PROMPT');
          break;
        case 'team':
          popupContent = $filter('translate')('DELETE_TEAM_PROMPT');
          break;
        case 'teamMember':
          popupContent = $filter('translate')('DELETE_TEAM_MEMBER_PROMPT');
          break;
        case 'campaign':
          popupContent = $filter('translate')('DELETE_CAMPAIGN_PROMPT');
          break;
        case 'contact':
          popupContent = $filter('translate')('DELETE_CONTACT_PROMPT');
          break;
        case 'investor':
          popupContent = $filter('translate')('DELETE_INVESTOR_PROMPT');
          break;
        case 'cart':
          popupContent = $filter('translate')('DELETE_CART_PROMPT');
          break;
        default:
          popupContent = $filter('translate')('DELETE_PROMPT');
      }

      return popupContent;
    }
  },
  template: ($element, $attrs) => {
    var buttonTemplate = `<button class="button button-crimson button-clear button-small" ng-click="$ctrl.openPopup($event);">
                            <i class="ion-ios-trash"></i>
                          </button>`;

    var actionButtonTemplate = `<button class="action-item button button-crimson ion-ios-trash" ng-class="{'icon-right': !isMobileView }" ng-click="$ctrl.openPopup($event);">
                            <span class="action-label">{{ 'DELETE' | translate }}</span>
                          </button>`;

    var optionButtonTemplate = `<ion-option-button class="button-crimson" ng-click="$ctrl.openPopup($event);">
                                    <i class="ion-ios-trash"></i>
                                    <p>{{ 'DELETE' | translate }}</p>
                                </ion-option-button>`;

    if ($attrs.buttonType === 'button') {
      return buttonTemplate;
    } else if ($attrs.buttonType === 'optionButton') {
      return optionButtonTemplate;
    } else if ($attrs.buttonType === 'actionButton') {
      return actionButtonTemplate;
    }
  }
};

export default deletePrompt;



/** WEBPACK FOOTER **
 ** ./src/app/directives/popups/deletePrompt.js
 **/